<script lang="ts">
	import PlanetSixPillars from '$lib/assets/about/pl-six-pillars.webp';

	const pillars = [
		{
			name: 'Daily Movement',
			color: 'orange',
			description:
				'Movement woven into daily life, not a separate fitness hobby. Walking to meet friends, cycling to a match, gardening, volunteering, and active travel all count. Inspired by Blue Zones, we reward natural, regular movement.'
		},
		{
			name: 'Nature & Environment',
			color: 'emerald',
			description:
				'The quality of the places people share - streets, parks, air, water, and green spaces. Our missions focus on visible, local improvement: cleaner streets, planted trees, less waste. When the environment improves, pride, safety, and social trust rise with it.'
		},
		{
			name: 'Family & Community',
			color: 'indigo',
			description:
				'At the heart of Planet League is belonging. Missions build mutual aid, welcome newcomers, create shared rituals, and ensure no one is left isolated. Strong social structure means neighbours know each other.'
		},
		{
			name: 'Skills & Learning',
			color: 'amber',
			description:
				'Resilient communities are full of capable people who help one another. We focus on learning, mentoring, practical skills, and civic knowledge - rewarding the sharing of skills as much as acquiring them.'
		},

		{
			name: 'Food',
			color: 'lime',
			description:
				'Food sits at the intersection of health, culture, ecology, and belonging. We encourage affordable, plant-forward meals that are often shared. Cooking, swapping, growing, and eating together become missions.'
		},

		{
			name: 'Pace of Life',
			color: 'sky',
			description:
				'Modern urban life is fast, pressured, and exhausting. We create micro-moments of slowness: screen-free time, quiet walks, early finishes, shared meals, recovery rituals. Communities thrive when people are not constantly rushed or overwhelmed.'
		}
	];
</script>

<div class="space-y-8">
	<div class="space-y-3 text-center">
		<div
			class="inline-block px-4 py-1.5 bg-white shadow-pl rounded-full text-sm font-bold tracking-tight w-fit"
		>
			Our framework
		</div>
		<div class="font-title text-2xl md:text-4xl leading-tight max-w-4xl mx-auto">
			Six foundations of a thriving community
		</div>
		<div class="text-slate-600 text-base leading-relaxed text-center">
			Synthesised from Bhutan's Gross National Happiness framework and the science of the world's
			Blue Zones
		</div>
	</div>

	<div class="grid justify-center max-w-lg mx-auto p-4 sm:p-0">
		<img src={PlanetSixPillars} alt="Planet Six Pillars" />
	</div>

	<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-4">
		{#each pillars as pillar (pillar.name)}
			<div
				class="p-6 rounded-2xl border-2 border-transparent transition-all duration-200 bg-white
              hover:shadow-pl hover:-translate-y-2
              "
			>
				<h3 class="text-xl font-bold mb-2">
					{pillar.name}
				</h3>

				<p class="text-sm leading-relaxed">
					{pillar.description}
				</p>
			</div>
		{/each}
	</div>
</div>
